import './search-input-box.scss'
import { bemClassBuilder } from '@vista-digital/bem-class-builder'
import { Icon } from '@vista-digital/occ-ui'
import type { ChangeEvent, ChangeEventHandler, Dispatch, ForwardedRef, SetStateAction } from 'react'
import { forwardRef, useState } from 'react'

const b = bemClassBuilder('search-input-box')

export const SearchInputBox = forwardRef(
    (
        props: {
            id: string
            placeholder?: string
            onQueryChangeHandler?: ChangeEventHandler<HTMLInputElement>
            onClickClear?: () => void
            showClearButton?: boolean
            setShowClearButton?: Dispatch<SetStateAction<boolean>>
        },
        ref: ForwardedRef<HTMLInputElement>
    ) => {
        const { id, placeholder, onQueryChangeHandler, onClickClear, showClearButton, setShowClearButton } = props
        const [inputValue, setInputValue] = useState<string>('')

        const onInputChange = (e: ChangeEvent<HTMLInputElement>) => {
            setInputValue(e.target.value)

            if (onQueryChangeHandler) {
                onQueryChangeHandler(e)
            }

            setShowClearButton?.(true)
        }

        const onClear = () => {
            setInputValue('')

            if (onClickClear) {
                onClickClear()
            }
        }

        const showClearButtonClass = inputValue.length > 0 && showClearButton ? 'show-clear-button' : ''

        return (
            <div className={b.block()}>
                <Icon name={'search'} className={b.element('icon')} />
                <input
                    id={id}
                    className={b.element('input')}
                    tabIndex={1}
                    autoComplete="off"
                    name="cc"
                    title="search"
                    role="searchbox"
                    ref={ref}
                    onChange={onInputChange}
                    placeholder={placeholder}
                />
                <button className={b.element('clear-icon', undefined, showClearButtonClass)} onClick={onClear}>
                    <Icon name={'cross-large'} />
                </button>
            </div>
        )
    }
)
